var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49982 11.4283C1.31338 11.4294 1.12856 11.3936 0.955953 11.3231C0.78335 11.2526 0.626361 11.1488 0.493987 11.0175C0.230132 10.752 0.0820313 10.393 0.0820312 10.0187C0.0820313 9.64446 0.230132 9.2854 0.493987 9.01997L8.99399 0.51997C9.12519 0.386112 9.28166 0.279621 9.45431 0.206668C9.62697 0.133714 9.81239 0.0957488 9.99982 0.0949707C10.1873 0.0957488 10.3727 0.133714 10.5453 0.206668C10.718 0.279621 10.8745 0.386112 11.0057 0.51997L19.5057 9.01997C19.7695 9.2854 19.9176 9.64446 19.9176 10.0187C19.9176 10.393 19.7695 10.752 19.5057 11.0175C19.374 11.1503 19.2173 11.2556 19.0446 11.3276C18.872 11.3995 18.6868 11.4365 18.4998 11.4365C18.3128 11.4365 18.1276 11.3995 17.955 11.3276C17.7824 11.2556 17.6257 11.1503 17.494 11.0175L9.99982 3.57997L2.56232 11.0175C2.4233 11.1558 2.25708 11.2637 2.07418 11.3344C1.89129 11.4051 1.69571 11.4371 1.49982 11.4283Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.b6647e26c713bb8e15a79810fb85eed3.svg";
export { ForwardRef as ReactComponent };